import {
  Avatar as MuiAvatar
} from "@mui/material";
import {
  Abbr
} from "../../../lib/String.lib";
import useState from "../../../lib/hooks/useState.hook";
import {
  joinClassName
} from '../Libraries/Theme.lib';

/**
 * Custom Avatar wrapper supporting fallback image (errorSrc)
 * and auto-hide behavior when both images fail.
 *
 * @param {object} props
 * @param {string} props.src
 * @param {string} props.errorSrc
 * @param {string} props.label
 * @returns JSX.Element
 */
export default function Avatar({
  src = "",
  errorSrc = "",
  label = "",
  children,
  ...props
}) {
  const [{ currentSrc = src }, update] = useState();

  const handleError = () => {
    setTimeout(async () => {
      if (currentSrc !== errorSrc && errorSrc) {
        await update({ currentSrc: errorSrc, failed: false });
      }
      else {
        await update({ failed: true });
      }
    });
  };

  const mergedProps = {
    ...props,
    src: currentSrc,
    className: joinClassName([
      props.className,
    ]),
    children: Abbr({ value: label || children }),
    imgProps: {
      onError: handleError
    }
  };

  return <MuiAvatar {...mergedProps} />;
}
